export default __webpack_public_path__ + "static/media/affiliation-letter-header.e78f9475.png";